//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export const standardSort = <T>(a: T, b: T) => (a > b ? 1 : b > a ? -1 : 0);

/**
 * Sorts an array of objects by the value associated with the given key. By default this
 * just sorts with the standard Array.sort method, but it also accepts a custom compareFn
 * method that mirrors the default sort:
 *
 * Given a, b =>
 *   • Returns a positive value if a > b
 *   • Returns 0 if a = b
 *   • Returns a negative va;ue if a < b
 */
export const sortBy = <
  T extends Record<PropertyKey, any>,
  K extends keyof T = keyof T,
>(
  arr: T[],
  key: K,
  compareFn: (a: T[K], b: T[K]) => number = standardSort,
) => {
  return [...arr.sort((a, b) => compareFn(a[key], b[key]))];
};
